import {formatFieldAsText, strip} from '@/common/questionsExporter/utility'

const matchingQuestion = (question) => {
    const pairReducer = (acc, pair) => {
        const left = pair.left ? formatFieldAsText(pair.left) : ''
        const right = pair.right ? formatFieldAsText(pair.right) : ''

        return `${acc}Left: ${left}\t\tRight: ${right}\n`
    }

    const answerPairs = question.answer_pairs ? question.answer_pairs.reduce(pairReducer, '') : ''
    const prompt = strip(question.question_prompt ? question.question_prompt : '')

    return `${prompt}\n${answerPairs}`
}

export {matchingQuestion}
